import { useEffect, useState } from "react";
import { useBranding } from "../../Context/BrandingContext";

/**
 * The Diamond Counter branded pre-loader, overlaid on the 360 Render iframe
 * (desktop inline viewer + mobile modal). Stays up until the embed posts
 * "tdr-embed-ready" (model fully loaded) — the parent flips `ready`, this
 * fades out, then unmounts. Background matches the viewer's light backdrop so
 * the reveal is seamless. Render Studio / share view never use this.
 */

const GOLD = "#C5A028";

export default function Preloader360({ ready }) {
  // Stay mounted through the fade, then drop out of the DOM.
  const [gone, setGone] = useState(false);
  const branding = useBranding();
  useEffect(() => {
    if (!ready) {
      setGone(false);
      return undefined;
    }
    const t = setTimeout(() => setGone(true), 750); // > the 0.7s opacity fade
    return () => clearTimeout(t);
  }, [ready]);

  if (gone) return null;

  return (
    <div
      aria-hidden={ready}
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 22,
        background: "#fff",
        opacity: ready ? 0 : 1,
        pointerEvents: ready ? "none" : "auto",
        transition: "opacity 0.7s ease",
      }}
    >
      <style>{KEYFRAMES}</style>
      <img
        src={branding.logo}
        alt={branding.name}
        style={{ width: 200, maxWidth: "65%", height: "auto", display: "block" }}
      />
      <div style={{ position: "relative", width: 132, height: 2, background: "rgba(0,0,0,0.08)", borderRadius: 2, overflow: "hidden" }}>
        <div style={{ position: "absolute", top: 0, bottom: 0, width: "42%", background: GOLD, borderRadius: 2, animation: "tdc360bar 1.15s ease-in-out infinite" }} />
      </div>
    </div>
  );
}

const KEYFRAMES = `
@keyframes tdc360bar {
  0%   { left: -44%; }
  100% { left: 100%; }
}
`;
